export default __webpack_public_path__ + "static/media/icon-veloprime-black.01a18c6d.png";